import { defineStore, acceptHMRUpdate } from 'pinia'

export const useTextAreaStore = defineStore('textArea', {
    state: () => ({
        message: '',
        messageMaxLength: 255
    }),
    actions: {
        setMessage(message) {
            this.message = message
        },
        clearMessage() {
            this.message = ''
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTextAreaStore, import.meta.hot))
}